<div class="b-input__table" (click)="clickInside($event,b)" w-click-outside [clickInsiders]="[d,b]"
  (clickOutside)="clickOutside()">
  <div class="b-input__table-td" class="b-flex-column">
    <div class="b-flex-row" [style.height.rem]="label ? 5 : 1.2" [style.margin-bottom.px]="label ? 0 : 8 ">
      <label class="b-input__label" [innerHTML]="label" [attr.for]="id"></label>&nbsp;
    </div>
    <div class="b-flex-row b-input-select-many__container" [style.max-height.px]="maxHeight"
      (click)="searchInput.focus()">
      <w-input-badge *ngFor="let item of dropdownSelected" [text]="getLabelAsync(item) | async" [disabled]="disabled"
        [style.flex-grow.px]="maxBadgeWidth" (wClose)="removeItem(item)" (click)="$event.stopPropagation()">
      </w-input-badge>
      <input #searchInput #i [id]="id" [name]="name" [attr.type]="type" [attr.disabled]="attr(isDisabled)"
        tabindex="0" 
        [attr.placeholder]="hasLabel || hasContent() ? '' : placeholder" [attr.maxlength]="maxLength"
        [attr.minlength]="minLength" [attr.pattern]="pattern" class="b-input__input b-input__text-input"
        (keydown)="keydown($event)" (keyup)="keyup($event)" (blur)="wBlur.emit($event)" [(ngModel)]="searchText" />
    </div>
  </div>
  <div class="b-input__button-wrapper" #b>
    <span class="b-workbench-filter__clear-search b-icon b-icon--close" *ngIf="!disabled"
      [style.visibility]="value?.length>0 ? 'visible' : 'hidden'" (click)="resetAll()"></span>
    <button #dd w-button buttonType="dropdown" (click)="dropDown($event)" [size]="buttonSize" [disabled]="disabled"
      tabindex="-1"></button>
  </div>
</div>
<div class="b-input__info--dropdown" #d>
  <w-input-dropdown *ngIf="showDropdown" [list]="dropdownList" [activeIndex]="activeIndex" [selected]="dropdownSelected"
    (wDropdownClick)="dropdownClick($event)"
    ></w-input-dropdown>
</div>


<f-facet-info [isError]="true">
  {{ error
  }}<ng-content select="f-facet[name=error],[facet-error]" description="Display error message"></ng-content>
</f-facet-info>
<f-facet-info>
  {{ info }}<ng-content select="f-facet[name=info],[facet-info]" description="Display info message"></ng-content>
</f-facet-info>